import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';

import { DataGrid } from 'src/common/DataGrid';

import { columns } from './columns';
import { PricingEmptyState } from './PricingEmptyState';
import { usePricingManagementViewModel } from './usePricingManagementViewModel';

export function PricingManagementRoute() {
  const {
    pricingSchemes,
    isPricingPricingSchemesLoading,
    pagination,
    handlePaginationChange,
  } = usePricingManagementViewModel();

  return (
    <>
      {isPricingPricingSchemesLoading ? (
        <div className="my-72 flex justify-center">
          <LoadingIndicator />
        </div>
      ) : (
        <DataGrid
          tableId="trip-subscription"
          columns={columns}
          data={pricingSchemes?.results || []}
          pagination={pagination}
          totalCount={pricingSchemes?.count || 0}
          handlePaginationChange={handlePaginationChange}
          emptyState={<PricingEmptyState />}
          getRowId={(row) => row.id}
        />
      )}
    </>
  );
}
